enum LogIndex {
  SwedenSelfTest = "project-sweden-selftest",
  UnifiedClient = "uc-frontend",
  FirebasePOC = "Sport-FirebasePOC",
  SpectateGradualDeployment = "project-spectate-gradual-deployment"
}

export default LogIndex;
